import React from "react";
import { useHistory } from "react-router-dom";
import { FiEdit2, FiEye } from "react-icons/fi";

import { AdminCourse, getCourseStatus } from "../../../../../models/CourseModels";
import {
  DataTable,
  DataTableColumn,
  StatusBadge,
  IconButton,
} from "../../../../../components/Admin";
import { DangerButton } from "../../../../_layout/AdminLayout.styles";

const STATUS_LABEL = {
  active: "Ativo",
  soon: "Em breve",
  inactive: "Inativo",
} as const;

const STATUS_TONE = {
  active: "positive",
  soon: "warning",
  inactive: "neutral",
} as const;

interface ICoursesTable {
  data: AdminCourse[];
  onDeactivate: (course: AdminCourse) => void;
  onEdit: (course: AdminCourse) => void;
  deletingId: string;
}

const CoursesTable: React.FC<ICoursesTable> = ({
  data,
  onDeactivate,
  onEdit,
  deletingId,
}) => {
  const { push } = useHistory();

  const columns: DataTableColumn<AdminCourse>[] = [
    {
      key: "thumb",
      header: "",
      width: "120px",
      render: (course) => (
        <img
          src={course.thumburl}
          width={96}
          alt=""
          style={{ borderRadius: 6 }}
        />
      ),
    },
    {
      key: "title",
      header: "Curso",
      align: "start",
      render: (course) => (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <strong>{course.title}</strong>
          <span style={{ fontSize: 12, opacity: 0.7 }}>{course.courseid}</span>
        </div>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (course) => {
        const status = getCourseStatus(course);
        return (
          <StatusBadge label={STATUS_LABEL[status]} tone={STATUS_TONE[status]} />
        );
      },
    },
    {
      key: "price",
      header: "Preço",
      render: (course) =>
        course.comingsoon === "true" ? "—" : `R$ ${course.price.toFixed(2)}`,
    },
    {
      key: "actions",
      header: "Ações",
      render: (course) => (
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          <IconButton label={`Editar ${course.title}`} onClick={() => onEdit(course)}>
            <FiEdit2 size={16} />
          </IconButton>
          <IconButton
            label={`Ver vendas de ${course.title}`}
            onClick={() => push(`/admin/sales?courseid=${course.courseid}`)}
          >
            <FiEye size={16} />
          </IconButton>
          {getCourseStatus(course) !== "inactive" && (
            <DangerButton
              type="button"
              onClick={() => onDeactivate(course)}
              disabled={!!deletingId}
            >
              {deletingId === course.courseid ? "Inativando..." : "Inativar"}
            </DangerButton>
          )}
        </div>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={data}
      rowKey={(course) => course.courseid}
      emptyMessage="Nenhum curso encontrado."
    />
  );
};

export default CoursesTable;
